export default class OutOfHours {

    constructor(){
        this.googleChromeBtn    = $('#google-chrome-download');
        this.desktopAppBtn      = $('#desktop-app-download');
        this.appStoreBtn        = $('#app-store-download');
        this.androidBtn         = $('#android-download');

        this.events()
    };

    events(){
        this.googleChromeBtn.on('click', (e) => {
            window.location.href = "https://www.google.com/chrome/?brand=BNSD&gclid=CjwKCAjwr56IBhAvEiwA1fuqGrEq2C7LFGdzfWk0ZiZCLAuMcR6hNgYIojKGS5xDrGyjOrd4EPT_UBoCEgEQAvD_BwE&gclsrc=aw.ds";
        });
        this.appStoreBtn.on('click', (e) =>{
            window.location.href = "https://apps.apple.com/app/kino-live/id1522590532";
        });
        this.androidBtn.on('click', (e) => {
            window.location.href = "https://play.google.com/store/apps/details?id=io.kinetx.kino";
        });
        this.desktopAppBtn.on('click', function(e){
            window.location.href = `${window.KINO_APP_URL || window.location.origin}/#download`
        });
    };

}
